import userStore from '../../../../stores/UserStore.js';
import { userCanAccessFds } from './utils.js';

export const requirements = {
  requiredUserPermissions: ['settlement-internal', 'settlement-view-and-edit'],
  flipFlopRequirements: ['program-reserve-beta'],
};

export const verifier = () => {
  return userStore.flipFlop.get('program-reserve-beta', false) && userCanAccessFds();
};
